import { Field, ErrorMessage } from "formik";
import { useState } from "react";
import { formatUnderscoreToSpace } from "../../utils/text-format";
import eyeOpen from "../../assets/icons/eye-line.svg";
import eyeClose from "../../assets/icons/eye-off-line.svg";

const FormPasswordField = ({
  label = "password",
  labelClassName = "",
  name = "password",
  className = "",
  placeholder = "",
  required,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, meta }) => (
          <div className={`flex flex-col gap-1 ${className} w-full`}>
            {label && (
              <label
                htmlFor={name}
                className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${labelClassName} ${
                  meta.touched && meta.error ? "text-errorColor" : ""
                }`}
              >
                {formatUnderscoreToSpace(label)}
              </label>
            )}
            <div className="relative">
              <input
                {...field}
                {...props}
                id={name}
                name={name}
                type={showPassword ? "text" : "password"}
                placeholder={placeholder}
                required={required}
                className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
                  text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none ${
                    meta.touched && meta.error
                      ? "border-errorColor"
                      : "border-greyText"
                  }`}
              />
              <button
                type="button"
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-greyText"
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? (
                  <img src={eyeOpen} alt="on" width={20} height={20} />
                ) : (
                  <img src={eyeClose} alt="on" width={20} height={20} />
                )}
              </button>
            </div>
            <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
              <ErrorMessage name={name} />
            </label>
          </div>
        )}
      </Field>
    </div>
  );
};

export default FormPasswordField;
